import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div>
      <div className="header">
        <h1>AWS Web Application</h1>
      </div>
      <div className="container">
        <div className="card">
          <h2>Welcome to AWS Web App</h2>
          <p>This is a full-stack web application with AWS integration.</p>
          <Link to="/dashboard">
            <button className="btn">Go to Dashboard</button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Home;
